import { I, SESSION_ICON } from "../components/icons";
import { NavRow, RowGroup } from "../components/Rows";
import { todayStr } from "../domain/date";
import { doseIndex, typeName } from "../domain/plan";
import { sessionMinutes } from "../domain/queue";
import { sessionGate } from "../domain/trainingQuestions";
import { useDeviceAnswers, useKaya, usePlayerMode, useTrainingDevice } from "../store/kayaStore";

/**
 * Morning yoga & breathing as a row on Train, for either programme (ADR-067): an extra a person
 * chooses, never the day's session, so the row says it can never be a missed day. It opens the
 * session's listing — where a left-out kapalbhati says why — and Start there runs it as an extra.
 * Where the safety answers hold the plan or stop it, the player would run something else, so the
 * row is not offered at all — and with `group`, nor is the heading it would sit under.
 */
export function YogaExtraRow({ group }: { group?: string } = {}) {
  const S = useKaya((s) => s.S);
  const answers = useDeviceAnswers();
  const device = useTrainingDevice();
  const pm = usePlayerMode();
  const today = todayStr();
  const gate = sessionGate(S, "YB", answers);
  if (gate.stop || gate.key !== "YB") return null;
  const mins = sessionMinutes(S, "YB", doseIndex(S, "YB", today), { device }, pm.simple);
  const done = (S.logs[today]?.extras ?? []).includes("YB");
  const row = (
    <NavRow
      title={typeName("YB")}
      subtitle={`${mins} min · seated · counts as active minutes, never as a missed day`}
      icon={I[SESSION_ICON.YB]}
      value={done ? "done today" : undefined}
      to="/train/yoga"
    />
  );
  return group ? <RowGroup heading={group}>{row}</RowGroup> : row;
}
